<button class="btn btn-primary btn-sm me-3" type="button" (click)="open(modalAgregarModal)">
  Agregar Concepto
</button>

<ng-template #modalAgregarModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Agregar concepto</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); searchProd('')"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="label-black label-form">Los campos con
          <i class="fas fa-asterisk text-danger"></i> son
          requeridos.</label>
      </div>
    </div>
    <form [formGroup]="formConceptos" class="row">
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Clave Producto/Servicio
          <i class="fas fa-asterisk text-danger"></i></label>
        <select2 placeholder="Buscador..." (search)="searchProd($event)"
          customSearchEnabled class="custom-select2" [data]="customListCatClaveProductServ" infiniteScroll
          formControlName="claveProdServ"></select2>
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">No. Identificacion</label>
        <input class="form-control" formControlName="noIdentificacion" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Cantidad <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" (input)="calcularImporte()" mask="separator.6" formControlName="cantidad" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Clave Unidad <i class="fas fa-asterisk text-danger"></i></label>
        <select2 placeholder="Buscador..." (update)="setClaveByClaveUnidad()" (search)="searchClaveUnidad($event)"
          customSearchEnabled class="custom-select2" [data]="customListCatClaveUnidad" infiniteScroll
          formControlName="claveUnidad"></select2>
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Unidad</label>
        <input class="form-control" readonly="true" formControlName="unidad" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Descripcion <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" formControlName="descripcion" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Valor Unitario <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" (input)="calcularImporte()" prefix="$" mask="separator.6" thousandSeparator=","
          formControlName="valorUnitario" placeholder="$0" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Descuento</label>
        <input class="form-control" (input)="calcularImporte()" prefix="$" mask="separator.6" thousandSeparator=","
          formControlName="descuento" placeholder="$0" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Importe <i class="fas fa-asterisk text-danger"></i></label>
        <input class="form-control" prefix="$" mask="separator.6" thousandSeparator="," formControlName="importe"
          readonly="true" placeholder="$0" />
      </div>
      <div class="col-xxl-3 col-md-4 mb-2">
        <label class="label-form">Objeto de Impuesto
          <i class="fas fa-asterisk text-danger"></i></label>
        <select class="form-select" formControlName="objetoImp" (change)="validateObjetoImp()">
          <option [value]="null">Selecciona una opción</option>
          @for (objeto of catObjetoImp; track $index) {
          <option [value]="objeto.key">
            {{ objeto.key + " - " + objeto.value }}
          </option>
          }
        </select>
      </div>
    </form>
    @if(haveImpuestos) {
      <hr>
      <app-form-impuestos-conceptos 
        (sendImpuestos)="setImpuestos($event)"
        [baseConcepto]="this.formConceptos.value['importe']"
      />
    }
  </div>
  <div class="modal-footer">
    <button 
    type="button" class="btn btn-primary" (click)="agregarConcepto()"><i class="fas fa-plus me-1"></i>Agregar concepto</button>
  </div>
</ng-template>

<app-custom-toaster></app-custom-toaster>